import { parse, transformAst, transformRules, simplifyRules, createFilterMapSort, stringifyAst } from "@home-gallery/query";
const sortByOrder = (a, b) => {
  const aOrder = a.order || 1;
  const bOrder = b.order || 1;
  return aOrder <= bOrder ? -1 : 1;
};
class QueryExecutor {
  plugins = [];
  textFns = [];
  transformRules = [...transformRules];
  queryHandlers = [];
  addQueryPlugins(plugins) {
    this.plugins.push(...plugins);
    this.plugins.sort(sortByOrder);
    this.textFns = this.plugins.filter((p) => p.textFn).map((p) => p.textFn);
    this.transformRules = this.#getTransformRules();
    this.queryHandlers = this.plugins.filter((p) => p.queryHandler).map((p) => p.queryHandler);
  }
  #getTransformRules() {
    const rules = [...transformRules];
    this.plugins.filter((p) => p.transformRules?.length).forEach((plugin) => {
      rules.push(...plugin.transformRules);
    });
    return rules;
  }
  async execute(entries, query, context) {
    const { textFn, queryErrorHandler } = context;
    const proxyQueryContext = {
      ...context,
      textFn: (entry) => {
        return textFn(entry) + " " + this.textFns.map((textFn2) => textFn2(entry)).join(" ");
      },
      queryErrorHandler: (ast, context2, reason) => {
        return !![...this.queryHandlers, queryErrorHandler].find((handler) => handler(ast, context2, reason));
      }
    };
    return parse(query).catch((e) => {
      throw new Error(`Failed to parse query '${query}': ${e}`, { cause: e });
    }).then((ast) => {
      const queryAst = transformAst(ast, proxyQueryContext, this.transformRules, simplifyRules);
      context.ast = ast;
      context.queryAst = queryAst;
      context.stringifiedQueryAst = stringifyAst(queryAst);
      return queryAst;
    }).then((queryAst) => {
      try {
        const [queryFilter, queryMapper, querySort] = createFilterMapSort(queryAst, proxyQueryContext);
        context.queryFilter = queryFilter;
        context.queryMapper = queryMapper;
        context.querySort = querySort;
        return [queryFilter, queryMapper, querySort];
      } catch (e) {
        throw new Error(`Failed to create query filter and sort function`, { cause: e });
      }
    }).then(([queryFilter, queryMapper, querySort]) => {
      let filtered;
      try {
        filtered = entries.filter(queryFilter);
      } catch (e) {
        throw new Error(`Failed to filter entries by queryFilter`, { cause: e });
      }
      let mapped;
      try {
        mapped = filtered.map(queryMapper);
      } catch (e) {
        throw new Error(`Failed to map filtered entries by queryMapper`, { cause: e });
      }
      try {
        return querySort(mapped, entries);
      } catch (e) {
        throw new Error(`Failed to sort filtered entries by querySort`, { cause: e });
      }
    });
  }
}
export {
  QueryExecutor
};
//# sourceMappingURL=queryExecutor.js.map
